<template>
  <v-app class="main-l">
    <notify/>
    <!-- APPLICATION BAR  -->
    <v-app-bar
      style="box-shadow:0 0 20px rgba(0, 0, 0, 0.13)"
      id="home-app-bar"
      flat
      app
      color="#F5F6F7"
    >
    <v-btn v-if="needShowBurgerMenu" icon @click="drawer = !drawer">
      <v-icon>mdi mdi-menu</v-icon>
    </v-btn>
      <v-col lg="3">
        <v-text-field
          flat
          solo
          background-color="transparent"
          hide-details
          append-icon="mdi-magnify"
          label="Search"
          class="hidden-sm-and-down"
        ></v-text-field>
      </v-col>

      <!-- <dr-layout-placeholder :model="{$ID:'pl1', Name:'toolbar'}"></dr-layout-placeholder> -->

      <v-spacer />
      <!-- right-side action items -->
      <v-badge  overlap :content="3" :value="3" color="red" offset-x="15" offset-y="18">
          <v-btn icon>

          <v-icon color="orange" class="pa-2">mdi mdi-bell-ring</v-icon>
          </v-btn>

      </v-badge>
          <v-btn icon>
           <v-icon class="pa-2">mdi mdi-cog</v-icon>

          </v-btn>

      <lang-switcher />

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-list dense style="background:transparent;" class="py-0 pl-3">
            <v-list-item v-on="on" two-line :class="'px-0'">
              <v-list-item-avatar>
                <img v-if="!needDefaultImage" :src="$store.state.auth.user.authData.userPhoto" @load="load() " @error="error()"/>
                <img v-else src="../assets/user-account.png"/>
              </v-list-item-avatar>

              <v-list-item-content style="flex-direction:column; align-items:start">
                <v-list-item-title>{{$store.state.auth.user.authData.userName}}</v-list-item-title>
                <v-list-item-subtitle>{{$store.state.auth.user.authData.login}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title @click="$authCore.SignOut()">{{$t('login.signOut')}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- NAVIGATION -->

    <v-navigation-drawer
      elevation="1"
      floating
      app
      v-model="drawer"
      :expand-on-hover="minidrawer"
      width="300"
    >
      <!-- <div @click="minidrawer = !minidrawer" class="drawer-toggler">
      <v-icon>mdi mdi-chevron-double-left</v-icon>
      </div>-->
      <div class="logo">
        <img src="@/assets/it-logo.svg" v-if="1" height="33px" class="pl-3 full-logo" />
        <img src="@/assets/logo.svg" height="33px" class="pl-3 small-logo" />
      </div>

      <NavigationMenu :items="sidebarItems" />
    </v-navigation-drawer>

    <!-- CONTENT -->
    <v-content  style="background:#f1f4f6">
      <v-progress-linear
      v-if="loader"
      indeterminate
      height="5"
      color="primary"
      absolute
    ></v-progress-linear>
      <v-container>
            <dr-layout-placeholder :model="{$ID:'pl3'+this.routeName, Name:'Main'}"></dr-layout-placeholder>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Notify from '@/components/Notify'
import LangSwitcher from '@/components/LangSwitcher'
export default {
  name: 'MainLayout',

  components: {
    Notify,
    LangSwitcher
  },
  watch: {
    isUserAuthenticated(val) {
      if (!val) {
        this.$routerCore.GoToHomePage()
      }
    }
  },
  data: () => ({
    drawer: true,
    minidrawer: true,
    items: [
      { title: 'Dashboard', icon: 'mdi-view-dashboard' },
      { title: 'Photos', icon: 'mdi-image' },
      { title: 'About', icon: 'mdi-help-box' }
    ],
    needDefaultImage: false
  }),
  computed: {
    routeName() {
      return this.$route.name
    },
    sidebarItems() {
      return this.$store.getters.AppNavigation
    },
    isUserAuthenticated() {
      return this.$authCore.isAuthenticated
    },
    loader() {
      return this.$store.getters.getProcessing
    },
    needShowBurgerMenu() {
      if (this.$vuetify.breakpoint.name == 'xl' || this.$vuetify.breakpoint.name == 'lg') { 
        this.setModeDrawer(true)
        return false
      }
      this.setModeDrawer(false)
      return true
    }
  },
  methods: {
    setModeDrawer(value) {
      this.minidrawer = value
    },
    load() {
      this.needDefaultImage = false
    },
    error() {
      this.needDefaultImage = true
    }
  }
}
</script>

<style lang="scss" >
.main-l{

nav.v-navigation-drawer {
  box-shadow: 0 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.small-logo {
  display: none;
}
.logo {
  height: 75px;
  background: #fafbfc;
  display: flex;
  align-items: center;
}
.v-navigation-drawer--mini-variant {
  .full-logo {
    display: none;
  }
  .small-logo {
    display: block;
  }
}

.drawer-toggler {
  $border: 1px solid #e2e5e7;
  display: flex;
  position: absolute;
  width: 20px;
  height: 20px;
  right: 0;
  top: 25px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-left: $border;
  border-top: $border;
  border-bottom: $border;
  cursor: pointer;
  z-index: 1000;
  i {
    display: block;
    font-size: 20px;
  }
}
}
</style>